/*
 *
 * # Example of usage:
 *
 * 1 - Component with text
 *    <Button type="default">Example Text</Button>
 *
 * 2 - Component with text and icon
 *    <Button type="default">
 *      <span className="custom-glyphicon icon-remove"></span>
 *      <span className="ml-10">Example Text</span>
 *    </Button>
 *
 * 3 - Component types
 *    <Button type="default" />
 *    <Button type="primary" />
 *    <Button type="success" />
 *    <Button type="warning" />
 *    <Button type="danger" />
 *
 * 4 - Disabled component
 *    <Button type="<<type>>" disabled />
 *
 * 5 - Component with onClick
 *    <Button onClick={function() {alert("test")}} />
 *
 * 6 - Component with href
 *    <Button href={{url: "https://www.google.com", name: "_top"}} />
 *
 * Note: You can use onClick or href, you can not use both.
 *
 */

"use strict";

var cx = require("classnames");
var ButtonClickWrapper = require("app/shared/components/Button/button-click-wrapper");

var Button = React.createClass({
  propTypes: {
    children: React.PropTypes.node.isRequired,
    onClick: React.PropTypes.func,
    href: React.PropTypes.shape({
      url: React.PropTypes.string,
      name: React.PropTypes.string
    }),
    type: React.PropTypes.oneOf(["default","primary","success","warning","danger","gray","filter", "link"]).isRequired,
    disabled: React.PropTypes.bool,
    category: React.PropTypes.string,
    className: React.PropTypes.string,
    id: React.PropTypes.string
  },

  getDefaultProps: function() {
    return {
      category: "btn",
      children: "Click",
      onClick: function() { }
    };
  },

  getClassName: function() {
    var className = cx(
      this.props.category,
      this.props.className,
      "btn-" + this.props.type,
      { "disabled": this.props.disabled }
    );

    return className;
  },

  render: function(){
    return (
      <ButtonClickWrapper disabled={this.props.disabled}
                      href={this.props.href}
                      onClick={this.props.onClick}>
        <button id={this.props.id} className={this.getClassName()}>
          {this.props.children}
        </button>
      </ButtonClickWrapper>
    );
  }
});

module.exports = Button;



// WEBPACK FOOTER //
// ./app/shared/components/Button/button.jsx